
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concierge/excursions/[slug]",
      function () {
        return require("private-next-pages/concierge/excursions/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concierge/excursions/[slug]"])
      });
    }
  